import Navigation from "@/components/Navigation";
import VehicleRegistration from "./VehicleRegistration";

interface StaffPortalProps {
  userRole: "staff" | "admin";
  userName: string;
  userId: number;
}

const StaffPortal = ({ userRole, userName, userId }: StaffPortalProps) => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation userRole={userRole} userName={userName} />
      <VehicleRegistration userRole={userRole} userName={userName} userId={userId} />
    </div>
  );
};

export default StaffPortal;